import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Path} from '../common/path';
import {RestResult} from '../models/response/rest-result';
import {CommonService} from './common.service';
import {SearchRequest} from '../models/request/search-request';
import {SosAnswerRequest} from '../models/request/sos/sos-answer-request';

@Injectable()
export class SosAnswerService {

  constructor(protected http: HttpClient,
              protected commonService: CommonService) {
  }

  getOne(sosAnswerId: number): Observable<RestResult> {
    return this.http.get<any>(
      Path.API_ENDPOINT +
      Path.SOS_ANSWER +
      Path.SOS_ANSWER_ID.replace(':sosAnswerId', sosAnswerId.toString())
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError)
    );
  }


  search(request: SearchRequest): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.SOS_ANSWER +
      Path.SEARCH, request
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError)
    );
  }

  create(request: SosAnswerRequest): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.SOS_ANSWER, request).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError)
    );
  }

  deleteMultiple(requests: any[]): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.SOS_ANSWER +
      Path.MULTIPLE +
      Path.DELETE, requests).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError)
    );
  }

  saveMultiple(requests: any[]): Observable<RestResult> {
    return this.http.post<any>(
      Path.API_ENDPOINT +
      Path.SOS_ANSWER +
      Path.MULTIPLE, requests).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError)
    );
  }

  remove(sosAnswerId: number): Observable<RestResult> {
    return this.http.delete<any>(
      Path.API_ENDPOINT +
      Path.SOS_ANSWER +
      Path.SOS_ANSWER_ID.replace(':sosAnswerId', sosAnswerId.toString())
    ).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError)
    );
  }

  update(request: SosAnswerRequest): Observable<RestResult> {
    return this.http.put<any>(
      Path.API_ENDPOINT +
      Path.SOS_ANSWER, request).pipe(
      map(
        result => {
          return result;
        }),
      catchError(this.commonService.handleError)
    );
  }
}
